@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    @if (cart.totalItems > 0) {
      <div class="cart-details-wrapper">
        <div class="cart-title">
          {{ "cartDetails.cartName" | cxTranslate }}
        </div>
        <cx-cart-item-list [orderItems]="entries" [cartIsLoading]="false" [promotionLocation]="promotionLocation"
        [options]="{
          isSaveForLater: false,
          optionalBtn: saveForLaterBtn
        }" [cartLoaded$]="cartLoaded$"></cx-cart-item-list>
      </div>
    }
    <div class="general-promotions">
      <cx-promotions [promotions]="(cart.appliedOrderPromotions || []).concat(cart.potentialOrderPromotions || [])">
      </cx-promotions>
    </div>
  }
  <ng-template let-ctx #saveForLaterBtn>
    @if (selectiveCartEnabled) {
      <div class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
        <button class="link cx-action-link" [disabled]="ctx.loading" (click)="saveForLater(ctx.item)" type="button">
          {{ "saveForLaterItems.saveForLater" | cxTranslate }}
        </button>
      </div>
    }
  </ng-template>
  <div class="wrapper-buttons">
    <button class="btn btn-send" (click)="removeCart(cart)">
      {{ "cartDetails.emptyCart" | cxTranslate }}
    </button>
  </div>
  @if (cart.possibleFreeDelivery) {
    <div class="free-shipment-container">
      @if (activeCartZone$ | async; as activeCartZone) {
        @if (remainingAmountForFreeDelivery(cart) > 0) {
          <p
            [innerHTML]="'orderCost.remainingFreeShipping' | cxTranslate: { remainingAmount:  remainingAmountForFreeDeliveryWithCommas(cart), country: activeCartZone.name }">
          </p>
        } @else {
          <p [innerHTML]="'orderCost.freeShippingCart' | cxTranslate"></p>
        }
      }
    </div>
  }
  <div class="bottom-cart-container">
    <div class="coupon-container">
      <div class="coupon-title">
        <div class="coupon-input">
          <app-custom-icons [type]="iconTypes.DISCOUNTS_ICON"></app-custom-icons>
          <a (click)="showCouponApply()">{{ 'voucher.coupon' | cxTranslate }}<span class="wrapper-icon-rotate"
          [@rotatedState]='state'></span></a>
        </div>
        <a [routerLink]="{ cxRoute: 'home' } | cxUrl" class="btn btn-block btn-send">
        {{ "cartDetails.continueShopping" | cxTranslate }}</a>
      </div>
      @if (showCoupon) {
        <div @fadeIn @fadeOut class="cart-coupon-wrapper">
          <app-cart-coupon [cart]="cart"></app-cart-coupon>
        </div>
      }
    </div>
  </div>
  <app-custom-unavailable-products></app-custom-unavailable-products>
}